import script from "./Control_User.vue?vue&type=script&setup=true&lang=js"
export * from "./Control_User.vue?vue&type=script&setup=true&lang=js"

import "./Control_User.vue?vue&type=style&index=0&id=b7f45d36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7f45d36"]])

export default __exports__